// @ai-generated 2026-07-28T15:01:24+00:00 by niklas.eicker@tngtech.com using Claude Opus 5
import { type ToolbarElements, type ToolbarOptions } from '@synqo/frontend-component-library';
import { useMemo } from 'react';

/**
 * Drops toolbar actions entirely instead of letting the table render them locked, for views where
 * the action can never become available. The caller decides what to hide.
 */
export function useToolbarElementsWithout(
    toolbarElements: ToolbarElements | undefined,
    hiddenActions: ToolbarOptions[] | undefined,
): ToolbarElements | undefined {
    return useMemo(() => {
        if (hiddenActions === undefined || hiddenActions.length === 0) {
            return toolbarElements;
        }

        const withoutHidden = (elements: ToolbarOptions[]) =>
            elements.filter((element) => !hiddenActions.includes(element));

        if (toolbarElements === undefined) {
            return withoutHidden;
        }
        if (Array.isArray(toolbarElements)) {
            return withoutHidden(toolbarElements);
        }
        // Also filter the result: a callback may add back an action it was handed.
        return (standardOptions: ToolbarOptions[]) => withoutHidden(toolbarElements(withoutHidden(standardOptions)));
    }, [toolbarElements, hiddenActions]);
}
